import ProductVatConfigForm from '@/pages/product-vat-config/ProductVatConfigForm';
import { businessEntityVatConfigScreen } from '@/pages/product-vat-config/productVatConfigScreenConfig';

interface BusinessEntityVatConfigFormProps {
  mode: 'create' | 'edit';
}

const BusinessEntityVatConfigForm = ({
  mode,
}: BusinessEntityVatConfigFormProps) => {
  return (
    <ProductVatConfigForm
      mode={mode}
      screenConfig={businessEntityVatConfigScreen}
    />
  );
};

export default BusinessEntityVatConfigForm;
